import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as statisticsItem1Api from "../../api/statisticsApi/statisticsItem1Api";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {
  WOStatisticsItem,
  initializeStatisticsItem,
} from "../../models/serverModels/workOrder/WOStatisticsItem";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import StatisticsItem1Form from "./StatisticsItem1Form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

const item1Schema = yup.object({
  itemName: yup.string().required("아이템명을 입력해주세요"),
  displayOrder: yup.number(),
});

const CreateItem1 = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<WOStatisticsItem>,
    Params.Create<WOStatisticsItem>
  >({
    api: statisticsItem1Api.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate("/Statistics");
        queryClient.invalidateQueries("statisticsCategoryList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<WOStatisticsItem>({
    defaultValues: initializeStatisticsItem,
    resolver: yupResolver(item1Schema),
  });
  const onSubmit: SubmitHandler<WOStatisticsItem> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeStatisticsItem, ...data, categoryUID: parseInt(id!)},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="항목 추가" />
      {isLoading && <MWProgress />}

      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <StatisticsItem1Form />
          <ConfirmButtonGroup link="/Statistics" cancelText="취소" confirmText="추가" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateItem1;
